<template>
  <footer v-if="showFooter" id="footer" class="app-footer">
    <div class="footer-title">
      <cv-link to="/">{{ t("app_name") }}</cv-link>
    </div>
    <footer-link />
  </footer>
</template>

<script setup lang="ts">
import FooterLink from "@modules/app/components/FooterLink";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

// Props declaration
interface Props {
  isPublicPage?: boolean;
}

const { isPublicPage = false } = defineProps<Props>();

// i18n
const { t } = useI18n();

// store
const store = useStore();

// computed
const isLogged = computed<boolean>(() => store.getters["auth/isLogged"]);

const showFooter = computed<boolean>(() => {
  return !isPublicPage || (isPublicPage && !isLogged.value);
});
</script>
